import React from "react";

export const buttons = [{
    title: "常见问题",
    key:"common",
    disabled:false,
},{
    title: "账号相关",
    key:"account",
    disabled:false,
},{
    title: "委托约稿",
    key:"badges",
    disabled:true,
},{
    title: "活动相关",
    key:"event",
    disabled:true,
},{
    title: "其他问题",
    key:"other",
    disabled:true,
}]

export type QAType = {
    common: QAItem[]
    account: QAItem[]
};

export type QAItem = { question: string; answer: string|React.ReactElement; nav_link?: string; nav_title?: string }


export const qa:QAType = {
    common:[{
        question: "约稿的流程是怎么样的？",
        answer:"约稿分为定制委托和橱窗委托，定制委可以到“主页”-“画师列表”中挑选喜爱的画师，在“画师主页”中直接投递，橱窗委托则可以在“橱窗”板块中挑喜爱的橱窗直接投递。",
        nav_link: "/help/tutorials/user/app-usage",
        nav_title: "点我查看委托小教学"
    },{
        question: "什么是集市功能？",
        answer:"集市是一个用于一口价买卖虚拟物品板块，您可以在集市中上架您希望出售的物品，例如商业模板。",
        nav_link: "/help/tutorials/market",
        nav_title: "点我查看集市FAQ"
    },{
        question: "为什么有些时候我上传的图片无法正常加载（显示感叹号）？",
        answer:"我们在所有公共区域（头像、作品、例图等等）都设立了图片审核机制，如果您的图片被判断为含有以下内容，将会被暂时屏蔽：\n 1、含有色情/性暗示/性器官等容易引起青少年不适或影响青少年身心健康的内容；2、含有政治、反动、暴恐、血腥暴力内容；当然，如果您认为您的内容不包含上面的内容，您只需要耐心等待图片人工审核即可，我们会及时回复您的图片访问。",
    },{
        question: "提现为什么不能秒到？需要多久才能到账？",
        answer:"我们的账务系统还在初期阶段，我们不希望出现算错帐、少算帐的现象发生。尽量避免大家出现退单不退钱，验收不到账的情况。因此我们设立了人工审核，一般情况下不超过24小时，审核通过后立即到账。",
    },{
        question: "以前APP是免费的，为什么现在要提现且收手续费了？",
        answer:"在开始之初，APP还是一个不成熟的状态，我们希望将APP变得更好，直到它以更加完善的状态呈现给大家。我们的APP在10月第一次正式展示在大家面前以后，加入兽聚汇的人数远超我们的预期，为了支撑大量的小动物能稳定的使用我们的APP，我们的支出也在极快的方式增长。因此我们需要一个方法来达到收支平衡，此外，拥有一定的收入也可以让兽聚汇在未来能够持续的将更多功能带给大家。",
    }],
    account:[{
        question: "我想要修改手机号，在哪里可以修改？",
        answer:"您可以点击我的——个人资料——手机号码，输入新手机号+验证码即可完成修改。注意哦～修改后原手机号登录将会被视为新账号，和本账号数据不共享哦～",
    },{
        question: "我可以同时实名两个账户吗？",
        answer:"不可以。一个自然人只能实名一个账号，实名系统设计之初的作用就是为了杜绝圈子内频发的破坏市场的交易行为（如跑单、流模、低价接稿、盗设售卖等）而设立的措施。我们明白坏人总是抓不完的，但是我们希望能通过提高坏人“作案门槛”来尽可能的构筑一个大家都能彼此信任的的交易环境。",
    },{
        question: "我可以通过注销账号的方式来实名第二个账号吗？",
        answer:"同样不可以，理由同上。实名是永久且不可移除的，注销并不会反转实名状态。而且账号一旦注销，同样的手机号将无法再次注册兽聚汇账号。您只能使用不同的手机号来注册并登录兽聚汇。",
    },{
        question: "我的画师资格显示被永久取消了，我该怎么办？",
        answer:"通常情况下，我们决定撤销一个画师的资格之前都会非常谨慎的判断，如果您的画师资格被永久取消，说明您的行为已经严重对市场环境造成了干扰或违反了我们的规定且多次警告无效。一旦被撤销，除非极个别情况，我们的客服也无法反转这个处罚结果。",
    }]
}
